// extracted by mini-css-extract-plugin
export default {"loadingPage":"K8_xtjDC"};